/**
 * errorCode de negócio do POST ProcessoVenda/etapa que a tela trata de forma própria. Espelha MoverVendaEtapaErrorCodeEnum
 * da API Vendas e do OrquestradorVendas (os demais erros voltam com errorCode 0).
 */
export enum MoverVendaEtapaErrorCodeEnum {
    /**
     * Voltar etapa ou cancelar um pedido com financeiro, estoque ou nota lançados (T17): nada foi gravado; a resposta traz
     * `integracoes` e a tela pergunta se o usuário quer mover e o que quer desfazer.
     */
    ConfirmarIntegracoes = 1,
}
